import styled from 'styled-components';

import type {ThemeColor} from '../../styles';

import {ms} from '../../styles/normalizeSize';
import {getColor} from '../../styles/utils';
import {Clickable} from '../Clickable';
import {Text} from '../Text';
import {View} from '../View';

type StyledProps = {
  activeColor?: ThemeColor;
  isActive?: boolean;
  isFirst?: boolean;
  isLast?: boolean;
};

export const Container = styled(View)`
  gap: ${ms(8)};
  flex-direction: column;
`;

export const RatingBar = styled(View)`
  width: 100%;
`;

export const Item = styled(View)`
  flex: 1 1 0;
  position: relative;
  flex-direction: column;
  row-gap: ${ms(6)};
`;

export const NumberContainer = styled(Clickable)<StyledProps>`
  background: ${p =>
    p.isActive
      ? getColor(p.activeColor || 'global1')(p)
      : getColor('background1')(p)};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: ${ms(48)};
  min-width: ${ms(20)};
  width: 100%;
  border: ${ms(1)} solid ${getColor('border2')};
  border-left-width: ${p => ms(p.isFirst ? 1 : 0)};
  border-radius: ${p => ms(p.isFirst ? 8 : 0)} ${p => ms(p.isLast ? 8 : 0)}
    ${p => ms(p.isLast ? 8 : 0)} ${p => ms(p.isFirst ? 8 : 0)};
`;

export const Label = styled(Text)<StyledProps>`
  font-size: ${ms(11)};
  line-height: ${ms(14)};
  color: ${getColor('text3')};
  text-align: ${p => {
    switch (true) {
      case p.isFirst:
        return 'left';
      case p.isLast:
        return 'right';
      default:
        return 'center';
    }
  }};
`;

export const NumberText = styled(Text)<StyledProps>`
  font-size: ${ms(14)};
  line-height: ${ms(20)};
  color: ${p => getColor(p.isActive ? 'text2' : 'text3')(p)};
`;
